import { render } from "./login-2.vue?vue&type=template&id=627eed4a&scoped=true"
import script from "./login-2.vue?vue&type=script&lang=js"
export * from "./login-2.vue?vue&type=script&lang=js"

import "./login-2.vue?vue&type=style&index=0&id=627eed4a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\iuril\\Documents\\econopro\\mainapp\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-627eed4a"]])

export default __exports__